<template>
  <div>
    <div @click="dialog = true" v-if="btn !== false">
      <slot />
    </div>
    <v-autocomplete
      :value="supervisor"
      :items="supervisors"
      :label="label === null ? $i18n.t('Supervisor') : label"
      @change="changedTo"
      @click:clear="clear"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
      :search-input.sync="filter"
      :disabled="disabled"
      autocomplete="off"
      :no-filter="true"
      :append-outer-icon="disabled === false ? 'mdi-magnify' : ''"
      @click:append-outer="dialog = true"
      :prepend-icon="prependIcon"
      :prepend-inner-icon="prependInnerIcon"
      v-if="btn === false"
    >
      <template v-slot:selection="data">
        <div ripple class="height32" v-if="multiple === false">
          <v-img
            :src="data.item.pic"
            height="20"
            width="24"
            style="float: left; margin-right: 10px"
          ></v-img>
          <div style="width: 90px; float: left; font-size: 14px">
            {{ data.item.name }}
          </div>
          <div style="min-width: 82px; float: left; font-size: 14px">
            {{ data.item.phone }}
          </div>
        </div>
        <div ripple v-else>
          <div
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >
            <v-img
              :src="data.item.pic"
              height="20"
              width="24"
              style="float: left; margin-right: 10px"
            ></v-img>
            <div style="float: left; font-size: 12px">{{ data.item.name }}</div>
          </div>
        </div>
      </template>
      <template v-slot:item="data" class="px-2">
        <v-list-item ripple class="px-0">
          <v-list-item-content class="px-0">
            <v-list-item-title class="px-0">
              <v-img
                :src="data.item.pic"
                height="20"
                width="24"
                style="float: left; margin-right: 10px"
              ></v-img>
              <div style="width: 90px; float: left; font-size: 12px">
                {{ data.item.name }}
              </div>
              <div style="min-width: 82px; float: left; font-size: 12px">
                {{ data.item.phone }}
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-toolbar color="white" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-card-account-details-outline</v-icon>
            {{ $i18n.t("Select Supervisor") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-row class="mb-2">
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Name')"
                class="purple-input"
                v-model="name"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                isd
                :label="$i18n.t('email')"
                class="purple-input"
                v-model="email"
              />
            </v-col>

            <v-spacer />
            <v-col cols="12" md="2" class="text-right pull-right my-3">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="black"
                    text
                    fab
                    x-small
                    @click="clearSearch()"
                    style="margin-right: 2px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                x-small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-btn
            v-if="!grid.records"
            class="text-center secondary--text pa-10"
            text
            color="primary"
            style="width: 100%"
            :loading="loading"
            >{{ $i18n.t("No records available") }}</v-btn
          >
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-spacer />
              <z-grid-record :grid="grid" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-simple-table dense v-if="grid.records">
                <thead>
                  <tr>
                    <th class="primary--text">{{ $i18n.t("Name") }}</th>
                    <th class="primary--text">{{ $i18n.t("Phone") }}</th>
                    <th class="primary--text">{{ $i18n.t("Role") }}</th>
                    <th class="text-right primary--text">
                      {{ $i18n.t("Action") }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="supervisor in grid.rows" :key="supervisor._id">
                    <td>{{ supervisor.name }}</td>
                    <td>
                      +{{ supervisor.countryCode }} - {{ supervisor.phone }}
                    </td>
                    <td>{{ supervisor.roleName }}</td>
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="float-right"
                            color="primary"
                            small
                            fab
                            text
                            dark
                            v-on="on"
                            @click="select(supervisor)"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                        </template>
                        <span>Edit</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-pagination
                v-if="grid.records"
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Themeable from "vuetify/lib/mixins/themeable";
import orderBy from "lodash/upperFirst";

@Component({
  name: "SupervisorSelect",
  props: {
    value: {
      default: null,
    },
    idOnly: {
      default: false,
    },
    disabled: {
      default: false,
    },
    label: {
      default: null,
    },
    multiple: {
      default: false,
    },
    clearable: {
      default: false,
    },
    btn: {
      default: false,
    },
    prependIcon: {
      default: undefined,
    },
    prependInnerIcon: {
      default: undefined,
    },
    rules: {
      default: () => [],
    },
  },
})
export default class SupervisorSelect extends (Vue, Themeable) {
  grid = {};
  rows = 20;
  url = "/api/supervisor/grid?rows=";
  name = "";
  email = null;
  on = null;
  page = 1;
  dialog = false;
  selected = [];
  supervisor = null;
  supervisors = [];
  filter = "";
  loading = false;

  async mounted() {
    await this.onValueChange(this.value);
  }

  async showPage(page) {
    this.loading = true;
    this.page = page;
    this.grid = await doGet(
      this.url + this.rows + this.filterUrl + "&page=" + page
    );
    this.loading = false;
  }

  async clearSearch() {
    this.name = null;
    this.email = null;
    this.page = 1;
    this.search();
  }

  select(supervisor) {
    this.supervisor = supervisor;
    this.supervisors = [supervisor];
    this.dialog = false;
    if (this.idOnly === false) {
      this.$emit("input", supervisor);
    } else {
      this.$emit("input", supervisor._id);
    }
  }

  async search() {
    let filterUrl = "";
    if (this.name) filterUrl += "&name=" + this.name;
    if (this.email) filterUrl += "&email=" + this.email;
    this.filterUrl = filterUrl;
    common.setLoading(true);
    await this.showPage(1);
  }

  tableHeight() {
    return window.innerHeight - 400 + "px";
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) {
      this.supervisor = newVal;
      if (this.idOnly === false) {
        this.$emit("input", newVal);
      } else {
        this.$emit("input", newVal._id);
      }
    } else {
      this.$emit("input", null);
    }
    if (!newVal) this.$emit("input", null);
  }

  clear() {
    this.filter = "";
    this.supervisor = null;
    this.$emit("input", null);
  }

  @Watch("filter")
  async onFilterChange(val) {
    if (val != null && val.length > 1 && val.length < 20) {
      const filter = val.toLowerCase();
      this.loading = true;
      const supervisors = await doGet("/api/supervisor/autofill?key=" + filter);
      if (supervisors != null && supervisors.length > 0) {
        orderBy(supervisors, ["name", "phone"], ["asc", "asc"]);
        this.supervisors = supervisors;
      } else {
        this.supervisors = [];
      }
      this.loading = false;
      if (this.supervisors != null && this.supervisors.length > 0 && focus)
        this.show = true;
    }
  }

  @Watch("dialog")
  async onDialogChange(val) {
    if (val) {
      try {
        this.grid = await doGet(this.url + this.rows);
      } catch (e) {
        common.setError(e.message);
      }
    }
  }

  @Watch("value")
  async onValueChange() {
    this.loading = true;
    this.supervisor = null;
    if (this.idOnly === false) {
      if (this.value && this.value.name) {
        this.supervisor = await doGet(
          "/api/supervisor/" +
            (this.value._id ? this.value._id : "null") +
            "/supervisorDetail?name=" +
            this.value.name
        );
        this.supervisors = [this.supervisor];
      }
    } else if (this.value) {
      this.supervisor = await doGet(
        "/api/supervisor/" + this.value + "/supervisorDetail"
      );
      this.supervisors = [this.supervisor];
    }
    this.loading = false;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.v-dialog > .v-card > .v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
</style>
